import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { Target } from 'lucide-react';

interface ProgressBarWidgetProps {
  config: {
    title?: string;
    goalLabel?: string;
    showPercentage?: boolean;
    colorScheme?: 'primary' | 'success' | 'warning';
  };
  data?: {
    current?: number;
    goal?: number;
  };
}

export function ProgressBarWidget({ config, data }: ProgressBarWidgetProps) {
  const current = data?.current ?? 0;
  const goal = data?.goal ?? 100;
  const percentage = Math.min((current / goal) * 100, 100);
  const title = config.title || 'Progress';

  return (
    <Card className="h-full">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium flex items-center gap-2">
          <Target className="h-4 w-4 text-primary" />
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <Progress value={percentage} className="h-3" />
        <div className="flex justify-between text-sm">
          <span className="text-muted-foreground">
            {current.toLocaleString()} / {goal.toLocaleString()}
          </span>
          {config.showPercentage !== false && (
            <span className="font-medium text-primary">{percentage.toFixed(0)}%</span>
          )}
        </div>
        {config.goalLabel && (
          <p className="text-xs text-muted-foreground">{config.goalLabel}</p>
        )}
      </CardContent>
    </Card>
  );
}
